<template>
  <div v-if="config.payload != null && config.payload.mapping != null">
    <b-row
      v-for="(rowQuery, index) in config.payload.mapping"
      :key="index"
      class="center-content"
    >
      <template v-for="(colQuery, idx) in rowQuery">
        <b-col :cols="colQuery.col" :key="idx">
          <b-row
            v-if="colQuery.cards != null && colQuery.cards.length > 0"
            class="center-content max-row-height"
          >
            <b-col v-for="(cardQuery, i) in colQuery.cards" cols="12" :key="i">
              <div
                v-if="
                  layoutData.data != null && layoutData.data[cardQuery] != null
                "
                class="max-height-panel multi-line"
              >
                <GlobalDashboardCard
                  :cardConfig="layoutData.data[cardQuery]"
                  :layoutData="layoutData"
                  :data="data"
                >
                </GlobalDashboardCard>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    BCard,
    GlobalDashboardCard: () =>
      import("@/views/components/dashboard/GlobalDashboardCard"),
  },
  props: {
    config: { default: {} },
    layoutData: { default: {} },
    data: { default: {} },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.center-content {
  justify-content: center;
}

.max-row-height {
  height: 100%;
}

.max-height-panel {
  height: calc(100% - 2rem);
}

.max-height-card {
  height: 100%;
}

.multi-line {
  border-left: 1.5px solid #e2e2e2;
  margin-top: 15px;
}
</style>
